// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import { graphConfig } from '../../../helpers/auth-config';
import { Client, LargeFileUploadSession, LargeFileUploadTask, LargeFileUploadTaskOptions, Range, FileUpload, StreamUpload, UploadEventHandlers, UploadResult } from "@microsoft/microsoft-graph-client";
import appConfig from '../../../helpers/config';

let graphClient: Client | undefined = undefined;

const ensureClient = (authProvider: AuthCodeMSALBrowserAuthenticationProvider) =>{
  if (!graphClient) {
    graphClient = Client.initWithMiddleware({
      authProvider: authProvider
    });
  }

  return graphClient;
}
// <GetUserSnippet>
export async function getUser(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<any> {
     
  const graphClient = ensureClient(authProvider);
  console.log("$$$$$$$$$$$$ ensureClient ###############", graphClient)
  // Return the /me API endpoint result as a User object
  try{
      const user: any = await graphClient.api('/me')
        // Only retrieve the specific fields needed
        .select('displayName,mail,mailboxSettings,userPrincipalName')
        .get();
        
      return user;
  }catch(error){
    console.log("##### error user getUser #####", error); 
  }
}
// </GetUserSnippet>


/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
// First, create an instance of the Microsoft Graph JS SDK Client class


export async function uploadLargeFile(authProvider: AuthCodeMSALBrowserAuthenticationProvider, fileObjArg:any, filesize:number, filename:any, folderId:any): Promise<UploadResult> {
    try{

		const graphClient = ensureClient(authProvider);
		const itemId = folderId;//"01NTYEWTVSBPPDVVQG7RDI72MR3UI63DZB";
		const siteId = appConfig.siteId;
		const url= graphConfig.graphAPIEndPoint+`sites/${siteId}/drive/items/${itemId}:/${filename}:/createuploadsession`;
		
		const file = fileObjArg;

		const totalSize = filesize;
	
		const progress = (range?: Range, extraCallbackParam?: unknown) => {
			// Implement the progress callback here
	
			console.log("uploading range: ", range);
			console.log(extraCallbackParam);
		};
	
		const uploadEventHandlers: UploadEventHandlers = {
			progress,
			extraCallbackParam: "any parameter needed by the callback implementation",
		};
	
		const options: LargeFileUploadTaskOptions = {
			rangeSize: 1024 * 1024,
			uploadEventHandlers,
		};
	
		// Create upload session for OneDrive or SharePoint Upload"
		const payload = {
			item: {
				"@microsoft.graph.conflictBehavior": "rename",
			},
			deferCommit: false
		};
	
		const uploadSession: LargeFileUploadSession = await LargeFileUploadTask.createUploadSession(graphClient, url, payload);
	
		const fileObject = new FileUpload(file, filename, totalSize);
		// console.log("fileObject", fileObject)
		// OR
		// You can also create an object from a custom implementation of FileObject
		const task = new LargeFileUploadTask(graphClient, fileObject, uploadSession, options);
		const uploadResult:any = await task.upload();
		
		let returnedObj:any = {_responseBody: uploadResult?._responseBody}
		
		try{
			const permission = {
				type: 'view',
				scope: 'anonymous',
				retainInheritedPermissions: false,
				// password: '',
				// expirationDateTime:"2023-12-01T09:07-07:00"
			};
			
			const itemIdFile = returnedObj?._responseBody?.id ? returnedObj?._responseBody?.id : ""; 
			
			const shareLink: any = await graphClient.api(`/sites/${siteId}/drive/items/${itemIdFile}/createLink`)
			.post(permission);	  
			if(uploadResult._responseBody && shareLink){
				uploadResult._responseBody.webUrl = shareLink?.link?.webUrl;
			}
		}catch(error){
		  console.log("##### error share Link #####", error); 
		}
		return uploadResult;
	}catch(error){
		console.log("###### error #######", error);
		return Promise.reject(error);
	}
}

